import TemplateResponseFieldRenderer from './TemplateResponseFieldRenderer';

export default TemplateResponseFieldRenderer;
